import { SVG, Path } from '@wordpress/primitives';

const myAccountIcon = (
    <SVG
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
    >
        <Path d="M2.5,20.25C2.5,20.25 2.499,16.146 5.803,13.683C7.191,12.649 9.168,11.891 12,11.891C14.832,11.891 16.809,12.649 18.197,13.683C21.501,16.146 21.5,20.25 21.5,20.25C21.5,20.664 21.164,21 20.75,21L3.25,21C2.836,21 2.5,20.664 2.5,20.25ZM4.069,19.5C4.069,19.5 19.931,19.5 19.931,19.5C19.766,18.395 19.206,16.306 17.301,14.886C16.116,14.003 14.418,13.391 12,13.391C9.582,13.391 7.884,14.003 6.699,14.886C4.794,16.306 4.234,18.395 4.069,19.5Z"/>
        <Path d="M12,3C14.618,3 16.76,5.203 16.76,7.935C16.76,10.667 14.618,12.87 12,12.87C9.382,12.87 7.24,10.667 7.24,7.935C7.24,5.203 9.382,3 12,3ZM12,4.5C10.192,4.5 8.74,6.048 8.74,7.935C8.74,9.822 10.192,11.37 12,11.37C13.808,11.37 15.26,9.822 15.26,7.935C15.26,6.048 13.808,4.5 12,4.5Z"/>
    </SVG>
);


export default myAccountIcon;